import { combineReducers } from 'redux';
import { reducer as responsive } from 'react-responsive-redux';

import user from './authReducer';
import modals from './modalReducer';
import schema from './schemaReducer';
import reviewsState from './reviewsReducer';
import flightsUi from './FlightsUiReducer';
import alertModal from './alertModalReducer';
import placesModal from './PlacesModalReducer';
import selectedTrek from './selectedTrekReducer';
import trekOverview from './trekOverviewReducer';
import selectedPlace from './selectedPlaceReducer';
import servicesModal from './addToDayModalReducer';
import overviewEditor from './overviewEditor';
import trekFiltersType from './filterTreksReducer';
import trekPayment from './trekPaymentReducer';
import lightboxState from './lightboxStateReducer';
import ratingsState from './ratingsReducer';

const rootReducer = combineReducers({
  lightboxState,
  trekPayment,
  trekOverview,
  flightsUi,
  trekFiltersType,
  schema,
  user,
  overviewEditor,
  selectedTrek,
  servicesModal,
  placesModal,
  selectedPlace,
  modals,
  alertModal,
  responsive,
  reviewsState,
  ratingsState,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js